<template>
    <div>
        <div class="feature-advan">
            <h2 style="font-weight: 700;font-size: 34px;">GB WhatsApp Advanced Features</h2>
            <div class="feature-advan-list">
                <div v-for="item in imgList" :key="item.key" style="text-align: center;flex-shrink: 0;"
                    @click="selectFeature(item)" :class="{ 'active': selectedFeature.name == item.name }">
                    <img :src="item.src" alt="" class="feature-advan-icon">
                    <div>{{ item.name }}</div>
                </div>
            </div>
        </div>
        <div class="feature-ul">
            <div class="feature-ul-item">
                <strong>{{ selectedFeature.title }}</strong><br>
                {{ selectedFeature.description }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Carousel",
    data() {
        return {
            selectedFeature: null,
            imgList: [
                {
                    src: require('@/assets/icon/image.svg'),
                    name: 'Original Images',
                    title: 'Send High-Quality Media Files:',
                    description: "Share photos and videos without compression, maintaining original resolution and clarity."
                },
                {
                    src: require('@/assets/icon/revoke.svg'),
                    name: 'Hide Typing',
                    title: 'Hide Typing & Recording Status:',
                    description: `Chat in complete privacy by hiding the "typing..." and "recording..." indicators.`
                },
                {
                    src: require('@/assets/icon/stop.svg'),
                    name: 'Anti-Revoke',
                    title: 'Anti-Revoke Messages:',
                    description: `View deleted messages and media even after the sender has removed them.`
                },
                {
                    src: require('@/assets/icon/auto-reply.svg'),
                    name: 'Schedule',
                    title: 'Schedule Messages: ',
                    description: `Automatically send messages at your preferred date and time — perfect for birthdays or reminders.`
                },
                {
                    src: require('@/assets/icon/message-unread.svg'),
                    name: 'Auto-Reply',
                    title: 'Auto-Reply Messages:',
                    description: ` Set smart auto-replies when you're busy or offline, just like WhatsApp Business.`
                },
                {
                    src: require('@/assets/icon/combinedshapecopy2.svg'),
                    name: 'Unread',
                    title: 'Unread Messages: ',
                    description: `Mark any message as unread to get back to it later or manage your response time more effectively.`
                },
                {
                    src: require('@/assets/icon/download-video.svg'),
                    name: 'Save Statuses',
                    title: 'Download Statuses:',
                    description: `Save your friends’ photos and videos from their status updates directly to your device.`
                },
                {
                    src: require('@/assets/icon/Incoming_call.svg'),
                    name: 'Who Can Call',
                    title: 'Disable Calls from Unknown Numbers:',
                    description: `Block incoming calls from people not in your contact list for enhanced privacy.`
                },
                {
                    src: require('@/assets/icon/themes.svg'),
                    name: 'Themes',
                    title: 'Change Fonts, Emojis, and Themes: ',
                    description: `Personalize your chats with custom styles, colorful themes, and a wide variety of emoji packs.`
                },
                {
                    src: require('@/assets/icon/account-switch.svg'),
                    name: 'Accounts',
                    title: 'Use Multiple Accounts:',
                    description: `Manage two or more WhatsApp numbers on the same device without needing dual-SIM support.`
                },
                {
                    src: require('@/assets/icon/notifications.svg'),
                    name: 'Notifications',
                    title: 'Custom Notifications:',
                    description: `Set unique tones, vibration patterns, and LED colors for each contact or group.`
                },
                {
                    src: require('@/assets/icon/lock.svg'),
                    name: 'Lock Chats',
                    title: 'Lock Individual Chats: ',
                    description: `Protect sensitive conversations with fingerprint or PIN locks for selected chats only.`
                },
            ],
            currentIndex: 0,
            carouselInterval: null
        }
    },
    created() {
        if (this.imgList.length > 0) {
            this.selectedFeature = this.imgList[0];
            this.startCarousel();
        }
    },
    beforeDestroy() {
        this.stopCarousel();
    },
    methods: {
        // 选择特性的方法
        selectFeature(item) {
            this.selectedFeature = item;
            this.currentIndex = this.imgList.findIndex(i => i.name === item.name);
            this.resetCarousel();
        },
        // 开始轮播
        startCarousel() {
            this.carouselInterval = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % this.imgList.length;
                this.selectedFeature = this.imgList[this.currentIndex];
            }, 2000);
        },
        // 停止轮播
        stopCarousel() {
            if (this.carouselInterval) {
                clearInterval(this.carouselInterval);
                this.carouselInterval = null;
            }
        },
        // 重置轮播计时器
        resetCarousel() {
            this.stopCarousel();
            this.startCarousel();
        }
    },
}
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;
.feature-advan {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    max-width: 1200px;
    margin: auto;
    overflow-x: auto;

    .feature-advan-list {
        display: flex;
        align-items: center;
        gap: 30px;
        padding-top: 20px;
        // grid-template-columns: repeat(6, 1fr);

        .feature-advan-icon {
            width: 60px;
            height: 60px;
            padding: 14px;
            border-radius: 50%;
            background: rgb(42, 130, 228);
            color: #fff;
            font-size: 20px;
            margin-bottom: 10px;
            transition: all 0.3s ease-in-out;

            &:hover {
                background: rgb(42, 130, 228);

            }
        }
    }
}

.feature-ul {
    max-width: 1200px;
    margin: auto;
    border-top: 1px solid #ccc;

    .feature-ul-item {
        // display: flex;
        // justify-content: center;
        margin: 20px auto;
        line-height: 40px;
        color: #000;
    }
}

.active {
    // background-color: #f0f0f0;
    transform: translateY(-4px);
    color: rgb(42, 130, 228);
}
@media (max-width: 768px) {
    .feature-advan{
        align-items: flex-start;
        overflow-x: hidden;
        .feature-advan-list{
            overflow-y: scroll;
            width: 90vw;
        }
    }
    .feature-ul .feature-ul-item{
        margin:30px 20px ;
    }
}
</style>